import Rollbar from "rollbar";
import { buildRollbarConfig } from "./rollbarConfig";

// Reports go through this instance. After a bundle containing it is on the
// CDN, the Rails browser snippet can be turned off with js_enabled = false.
const rollbar = new Rollbar(
  buildRollbarConfig(
    typeof window === "undefined" ? "" : window.location.hostname
  )
);

export function setRollbarPerson(
  person: { id: string; email?: string } | null
) {
  if (!person) {
    // configure merges, and it skips undefined, so null is what clears person.
    rollbar.configure({
      payload: { person: null as unknown as Rollbar.PersonParams },
    });
    return;
  }
  rollbar.configure({
    payload: {
      person: {
        id: person.id,
        ...(person.email ? { email: person.email } : {}),
      },
    },
  });
}

export default rollbar;
